import axios from "axios";

export async function fetchDeliveryStatuses(items) {
  if (!items.length) {
    return [];
  }

  try {
    const res = await axios.post('ajax/products-stock', {productIdAndUnitList: items});
    return Array.isArray(res.data) ? res.data : [];
  } catch (e) {
    return [];
  }
}
